/** @jsx jsx */
import { jsx } from 'theme-ui';
import { lighten } from '@theme-ui/color';
import { createContext, Suspense, useContext, useEffect, useState, } from 'react';
import { CustomScroll } from './CustomScroll';
import { desaturate } from 'polished';
import { BigSpinner } from './BigSpinner';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { Button } from './Button';
import { useLocation } from 'react-router';
var SidebarContext = createContext(null);
export function useToggleSidebar() {
    return useContext(SidebarContext);
}
export var SidebarAppPage = function (_a) {
    var className = _a.className, sidebar = _a.sidebar, children = _a.children;
    var _b = useState(false), expanded = _b[0], setExpanded = _b[1];
    var location = useLocation();
    useEffect(function () {
        setExpanded(false);
    }, [location]);
    return (jsx(SidebarContext.Provider, { value: setExpanded },
        jsx("div", { className: className, sx: {
                display: 'flex',
                flexDirection: ['column', 'row'],
                width: '100%',
                height: ['unset', '100%'],
                position: 'relative',
                flex: 1,
            } },
            jsx("div", { sx: {
                    display: 'flex',
                    flexDirection: ['row', 'column'],
                    alignItems: 'stretch',
                    width: ['100vw', 220],
                    background: function (t) { return desaturate(0.3, lighten('secondary', 0.69)(t)); },
                    position: ['absolute', 'initial'],
                    right: [expanded ? 0 : '100vw', 'unset'],
                    height: ['100%', 'unset'],
                    transition: 'right 0.3s ease-in-out',
                    zIndex: 1,
                } },
                jsx(Button, { sx: {
                        display: ['inline-block', 'none'],
                        position: 'absolute',
                        right: 0,
                        ml: '-1px',
                        background: function (t) { return desaturate(0.3, lighten('secondary', 0.69)(t)); },
                    }, variant: "secondary", onClick: function () {
                        setExpanded(function (value) { return !value; });
                    }, icon: faChevronLeft }),
                jsx(CustomScroll, { sx: {
                        flexGrow: 1,
                        flexShrink: 1,
                        flexBasis: 0,
                        p: 3,
                    } }, sidebar),
                jsx("div", { sx: {
                        display: ['none', 'block'],
                        width: 6,
                        opacity: 0.4,
                        background: 'linear-gradient(to left, rgba(0, 0, 0, 0.2) 0px, rgba(0, 0, 0, 0.2) 1px, rgba(0, 0, 0, 0.1) 1px, rgba(0, 0, 0, 0) 100%)',
                    } })),
            jsx("div", { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                } },
                jsx(Suspense, { fallback: jsx(BigSpinner, null) }, children)))));
};
//# sourceMappingURL=SidebarAppPage.js.map